import { render, staticRenderFns } from "./CustomSelectMenu.vue?vue&type=template&id=56261d7e&scoped=true&"
import script from "./CustomSelectMenu.vue?vue&type=script&lang=ts&"
export * from "./CustomSelectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelectMenu.vue?vue&type=style&index=0&id=56261d7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56261d7e",
  null
  
)

export default component.exports